export default __webpack_public_path__ + "static/media/leadenball.40fe59f2.png";